import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-b907b57e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "FeedbackFormItem"
};
var _hoisted_2 = {
  "class": "title"
};
export default /*#__PURE__*/_defineComponent({
  props: {
    title: String
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1), _renderSlot(_ctx.$slots, "default")]);
    };
  }
});